"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = linkedTable;

function linkedTable(sliceData, linkedContent) {
  return linkedContent && sliceData.primary && sliceData.primary.linked_table && linkedContent.find(function (linkedItem) {
    return linkedItem.id === sliceData.primary.linked_table.id;
  });
}